import { createFileRoute } from '@tanstack/react-router'
import { getPatientMedicalPlanQuery, getPatientMedicationQuery, getPatientNotesQuery, getPatientQuestionnaireQuery, getPatientTimeline } from '~/features/dashboard/pages/quick-actions/api/queries/patient-log';
import { PatientLogDetailsPage } from '~/features/dashboard/pages/patient-logs/pages/patient'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$program/patients/patient/$id',
)({
   validateSearch: (search) => ({
    name: String(search.name ?? ""),
    sessionId: search.sessionId ? String(search.sessionId) : "",
  }),
  loader: async ({ context, params }) => {
    const patientId = params.id;

    // Prefetch all queries you need
    await Promise.all([
      context.queryClient.ensureQueryData(getPatientMedicalPlanQuery({ patient_id: patientId })),
      context.queryClient.ensureQueryData(getPatientMedicationQuery({ patient_id: patientId })),
      context.queryClient.ensureQueryData(getPatientTimeline({ patient_id: patientId })),
      context.queryClient.ensureQueryData(getPatientNotesQuery({
        opts: { patient_id: patientId },
        params: { skip: 0, sort_by_closest: true, limit: 2 }
      })),
      context.queryClient.ensureQueryData(getPatientQuestionnaireQuery({ patient_id: patientId })),
    ]);
  },
  component: () => (
    <section 
      role="region"
      aria-label="Dashboard overview"
      className="min-h-screen w-full mx-auto">
      <PatientLogDetailsPage />
    </section>
  ),
  errorComponent: ({ error }: { error: Error }) => (
    <div
      role="alert"
      className="flex min-h-screen items-center justify-center p-4"
    >
      <div className="text-center">
        <h1 className="text-2xl font-bold">Patient Details Error</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
})


